import $ from 'jquery';
import { generateQrCode } from '~src/sidebar/qr';
import { onErrorShowMessage } from '~src/errors';
import Swal from 'sweetalert2';
import { trackEvent } from '~src/tracking';
import { isURL, createPhoneUrl, createWhatsappUrl } from '~src/utils';
import {
  QR_TYPE_WEBSITE,
  QR_TYPE_WHATSAPP,
  QR_TYPE_PHONE,
} from '~config/editorConstants';

export const handleQrForm = async (e) => {
  e.preventDefault();

  $('#qr-form-user-input').removeClass('is-invalid');

  const qrTypeSelected = $('.qr-active').text();

  const userInput = $('#qr-form-user-input').val();

  let verifiedInput = '';

  const landlineNumbersRegex = /(0{1}[1-9]{1,3})[\s|.|-]?(\d{4,})/;
  const mobileNumbersRegex = /^([+]\d{2})?\d{9,12}$/;

  if (userInput === '') {
    $('#qr-form').addClass('needs-validation');
    $('#qr-form-input-error').text('Si prega di compilare questo campo');
    $('#qr-form-user-input').addClass('is-invalid');
    return;
  }

  if (qrTypeSelected === QR_TYPE_WEBSITE) {
    userInput.startsWith('http')
      ? (verifiedInput = userInput)
      : (verifiedInput = `https://${userInput}`);

    if (!isURL(verifiedInput)) {
      $('#qr-form').addClass('needs-validation');
      $('#qr-form-input-error').text('Inserisci un sito web valido');
      $('#qr-form-user-input').addClass('is-invalid');
      return;
    }
  }

  if (qrTypeSelected === QR_TYPE_WHATSAPP) {
    const cleanInput = userInput.replace(/\s/g, '').replace(/\./g, '');

    if (mobileNumbersRegex.test(cleanInput)) {
      verifiedInput = createWhatsappUrl(cleanInput);
    } else {
      $('#qr-form').addClass('needs-validation');
      $('#qr-form-input-error').text(
        'Inserisci cellulare, esempio: 3281445102'
      );
      $('#qr-form-user-input').addClass('is-invalid');
      return;
    }
  }

  if (qrTypeSelected === QR_TYPE_PHONE) {
    const cleanInput = userInput.replace(/\s/g, '').replace(/\./g, '');

    if (landlineNumbersRegex.test(cleanInput)) {
      verifiedInput = createPhoneUrl(cleanInput);
    } else {
      $('#qr-form').addClass('needs-validation');
      $('#qr-form-input-error').text(
        'Inserisci telefono, esempio: 03939066170'
      );
      $('#qr-form-user-input').addClass('is-invalid');
      return;
    }
  }

  Swal.fire({
    text: 'Sto generando il QR code',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  $('#qr-form').addClass('was-validated');

  try {
    await generateQrCode(verifiedInput);

    $('#qr-form-user-input').val('');
    $('#qr-form').removeClass('needs-validation was-validated');
    $('#qr-form-input-error').text('');

    Swal.fire({
      title: 'Fatto!',
      html:
        'Il codice QR &egrave; stato aggiunto al progetto e salvato tra i tuoi allegati',
      icon: 'success',
      confirmButtonColor: '#278e8e',
    });

    trackEvent('Create QR Code', {
      success: true,
      type: 'click',
      source: 'sidebar',
      qr_type: qrTypeSelected,
    });
  } catch (err) {
    console.error(err);
    onErrorShowMessage();
    trackEvent('Create QR Code', {
      success: false,
      type: 'click',
      source: 'sidebar',
      qr_type: qrTypeSelected,
    });
  }

  Swal.hideLoading();
};
